import React from "react";
import { motion } from "framer-motion";
import './redacted.css';
import { redactedVariants } from "./variants";


const Redacted = ({delay, duration}) => {
    return(
        <motion.span 
            className="redacted"
            variants={redactedVariants}
            custom={[delay,duration]}
        />
    )
}

export default Redacted;